import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  signInMethod: {
    defaultMessage: 'Sign in method',
    id: 'ChooseAuthMethodOverlay.signInMethod',
  },
  chooseConnectionMethod: {
    defaultMessage: 'What method would you like to connect with?',
    id: 'ChooseAuthMethodOverlay.chooseConnectionMethod',
  },
});
